import { forwardRef } from 'react';

import { type ButtonProps } from '../../../../tailwind';
import { FiltersPopoverSwitchFilterViewButton } from '../../filter-popover';
import { useChangeFiltersPopoverViewContext } from '../ChangeFiltersPopoverView.context';

export const SwitchViewButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    const [state, dispatch] = useChangeFiltersPopoverViewContext();
    const { current } = state;
    return (
      <FiltersPopoverSwitchFilterViewButton
        className={className}
        filterView={current === 'general' ? 'general' : 'advanced'}
        onFilterViewChange={(view) =>
          dispatch({ type: 'GO_TO', payload: view })
        }
        ref={ref}
        {...props}
      />
    );
  },
);
